var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"listing-price",class:{ sold: _vm.isSold }},[(_vm.isSold && _vm.displayIsSold)?_c('span',[_vm._v(_vm._s(_vm.$t("sold")))]):_vm._e(),_vm._v(" "+_vm._s(_vm.$n(_vm.price, "currency", "fr-FR"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }